const aiEn = {
  "ai.title": "AI Builder",
  "ai.open": "AI Builder",
  "ai.close": "Close AI Builder",
  "ai.write_with_ai": "Write with AI",
  "ai.credits_left": "{n} credits left this month",
  "ai.credits_today": "{n} left today",
  "ai.off_no_key": "The AI Builder isn't set up on this platform yet.",
  "ai.off": "The AI Builder isn't available for your store right now.",
  "ai.out_of_credits": "You've used this month's AI credits. They renew on {date}.",
  "ai.pick_theme": "Theme to work on",
  "ai.no_theme": "Content only (no theme changes)",
  "ai.theme_live": "{name} (live)",
  "ai.placeholder": "Ask for a change: “make the hero darker”, “add a Ramadan offers section”, “write Arabic descriptions for my abayas”…",
  "ai.send": "Send",
  "ai.stop": "Stop",
  "ai.stopping": "Stopping…",
  "ai.new_chat": "New conversation",
  "ai.history": "Earlier conversations",
  "ai.empty_intro": "Tell the AI what to change in your store. It prepares the changes in a draft; you preview them and apply when you're happy.",
  "ai.disclaimer": "AI can make mistakes. Review the changes before you apply them.",
  "ai.selected": "{count, plural, one {# product selected} other {# products selected}}",
  "ai.working": "Working…",
  "ai.thinking": "Planning…",
  "ai.step.understanding": "Understanding your request",
  "ai.step.planning": "Planning the work",
  "ai.step.get_store_profile": "Reading your store settings",
  "ai.step.get_theme_contract": "Reading the theme",
  "ai.step.list_template_sections": "Reading the page",
  "ai.step.read_theme_file": "Reading a theme file",
  "ai.step.get_locale_strings": "Reading theme texts",
  "ai.step.list_products": "Looking at products",
  "ai.step.get_product": "Reading a product",
  "ai.step.list_collections": "Looking at collections",
  "ai.step.get_collection": "Reading a collection",
  "ai.step.list_pages": "Looking at pages",
  "ai.step.get_page": "Reading a page",
  "ai.step.analyze_image": "Looking at an image",
  "ai.step.run_seo_audit": "Checking your SEO",
  "ai.step.set_theme_settings": "Changing theme settings",
  "ai.step.apply_preset": "Applying a theme style",
  "ai.step.add_section": "Adding a section",
  "ai.step.update_section_settings": "Changing a section",
  "ai.step.move_section": "Moving a section",
  "ai.step.remove_section": "Removing a section",
  "ai.step.add_block": "Adding a block",
  "ai.step.remove_block": "Removing a block",
  "ai.step.create_custom_section": "Building a new section",
  "ai.step.set_locale_strings": "Changing theme texts",
  "ai.step.update_product_content": "Writing product content",
  "ai.step.update_collection_content": "Writing collection content",
  "ai.step.update_page_content": "Writing page content",
  "ai.step.update_image_alt": "Writing alt text",
  "ai.step.update_home_seo": "Writing your home page SEO",
  "ai.step.validate_changeset": "Checking the changes",
  "ai.step.render_preview": "Previewing the page",
  "ai.step.ask_merchant": "Asking you a question",
  "ai.step.finish": "Wrapping up",
  "ai.status.queued": "The AI is busy; your request is next…",
  "ai.status.batch": "Writing {count, plural, one {# item} other {# items}} in the background. You'll be notified when it's done; you can close this panel.",
  "ai.status.waiting": "Waiting for your answer",
  "ai.status.budget": "Stopped at this job's limit",
  "ai.status.failed": "Something went wrong",
  "ai.status.cancelled": "Stopped",
  "ai.changes_title": "Changes",
  "ai.changes_none": "No changes were made.",
  "ai.preview_note": "Theme changes are in the editor's preview. Content changes go live when you apply.",
  "ai.apply": "Apply",
  "ai.discard": "Discard",
  "ai.undo": "Undo",
  "ai.applied": "Applied",
  "ai.applied_toast": "Changes applied",
  "ai.discarded": "Discarded",
  "ai.undone": "Undone",
  "ai.undone_toast": "Changes undone",
  "ai.show_details": "Show details",
  "ai.hide_details": "Hide details",
  "ai.before": "Before",
  "ai.after": "After",
  "ai.include": "Include",
  "ai.new_section_file": "New section file",
  "ai.conflicts_title": "Changed since the AI worked on it",
  "ai.conflicts_body": "Someone changed these after the AI did. Choose which version to keep for each.",
  "ai.keep_ai": "Use the AI's",
  "ai.keep_mine": "Keep the other change",
  "ai.apply_resolved": "Apply",
  "ai.invalid_changes": "The changes still have problems. Ask the AI to fix them, or discard them.",
  "ai.estimate_title": "This is a bigger job",
  "ai.estimate_body": "It uses at most {credits} credits ({left} left this month).",
  "ai.estimate_background": "It runs in the background and costs less.",
  "ai.estimate_confirm": "Go ahead",
  "ai.cancel": "Cancel",
  "ai.feedback_up": "Good result",
  "ai.feedback_down": "Not helpful",
  "ai.feedback_comment": "What could be better? (optional)",
  "ai.feedback_thanks": "Thanks for the feedback",
  "ai.feedback_send": "Send",
  "ai.suggest.home_meta_missing": "Write my home page's meta title and description",
  "ai.suggest.product_meta_missing": "{count, plural, one {Write the SEO title and description for the # product missing one} other {Write SEO titles and descriptions for the # products missing them}}",
  "ai.suggest.product_description_thin": "{count, plural, one {Write a fuller description for the # product with a short one} other {Write fuller descriptions for the # products with short ones}}",
  "ai.suggest.arabic_missing": "{count, plural, one {Write the Arabic title and description for # product} other {Write Arabic titles and descriptions for # products}}",
  "ai.suggest.image_alt_missing": "{count, plural, one {Add alt text to the # image without it} other {Add alt text to the # images without it}}",
  "ai.suggest.collection_meta_missing": "{count, plural, one {Write SEO for the # collection missing it} other {Write SEO for the # collections missing it}}",
  "ai.suggest.theme_darker": "Make the store look more luxurious",
  "ai.suggest.theme_offers": "Add a Ramadan offers section to the home page",
};

export default aiEn;
